import { Dispatch, SetStateAction, useState } from "react"
import { Modal } from "../components/design-system/Modal"
import { formatRewardsType } from "../data/shared/utils/formatRewardsType"
import { formatSpendCategory } from '../data/shared/utils/formatSpendCategory'
import { formatEarnRate } from '../data/shared/utils/formatEarnRate'
import { flattenObject } from '../data/shared/utils'
import { CreditCard } from 'data/shared/CreditCard'
import { CreditCardData } from 'data/shared/CreditCardData'
import { categoryEmojiMap } from "../data/shared/utils/CategoryEmojiMap"

export const useCardModal = (handleRemoveCard?: (_: CreditCard) => void): [null | React.ReactElement, Dispatch<SetStateAction<CreditCard | undefined>>] => {
  const [showCardModalCard, setShowCardModal] = useState<CreditCard | undefined>(undefined)
  if (!showCardModalCard) {
    return [null, setShowCardModal]
  }

  const cardInfo = CreditCardData[showCardModalCard]

  const earnRates = flattenObject(cardInfo.rewards_earn_rates)

  return [
    <Modal
      isOpen={true}
      handleClose={() => setShowCardModal(undefined)}
      extraFooterButtons={
        handleRemoveCard ? (
          <button
            style={{
              padding: '8px 16px',
              backgroundColor: '#F62F2F',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              cursor: 'pointer',
              marginTop: 8,
            }}
            onClick={() => {
              handleRemoveCard(showCardModalCard);
              setShowCardModal(undefined);
            }}
          >
            Remove card from wallet
          </button>
        ) : undefined
      }
    >
      <div
        style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
      >
        <img
          src={`cards/${cardInfo.imageName}`}
          alt={cardInfo.name}
          style={{
            width: 120,
            maxHeight: 90,
            boxShadow: '0 5px 20px rgba(0, 0, 0, 0.3)',
            marginRight: 15,
          }}
        />
        <h2>{cardInfo.name}</h2>
      </div>
      <p>Earn {formatRewardsType(cardInfo.rewardsType)}</p>

      {Object.entries(earnRates).map(
        ([earnRateKey, earnRateValue]: [
          earnRateKey: string,
          earnRateValue: number
        ]) => {
          return (
            <p>
              {categoryEmojiMap[earnRateKey]} Earn{' '}
              {formatEarnRate(earnRateValue, cardInfo.rewardsType)} on{' '}
              {formatSpendCategory(earnRateKey)}
            </p>
          );
        }
      )}
      {
        cardInfo.bank_name || cardInfo.issuer ? (
          <p>
            Issued by {cardInfo.bank_name || cardInfo.issuer}
          </p>
        ) : null
      }

      <p>
        {cardInfo.rewardsSummary}
      </p>
      <p>
        {cardInfo.cardSummary}
      </p>
    </Modal>,
    setShowCardModal,
  ];
}